"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TranscriptConverter = void 0;
class TranscriptConverter {
    static GenerateFilename(dispositionHeader, videoTitle) {
        const regex = /filename="(.*?)"/;
        const matches = regex.exec(dispositionHeader);
        const matchedFilename = matches?.[1];
        if (matchedFilename) {
            return matchedFilename;
        }
        const filename = videoTitle.replace(/[.: ]/g, '_');
        return `${filename}.txt`;
    }
}
exports.TranscriptConverter = TranscriptConverter;
//# sourceMappingURL=TranscriptConverter.js.map